var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"texto",staticStyle:{"text-align":"justify"}},[_vm._v("\n    Olá "),(_vm.profissao === true)?_c('span',[_vm._v("Dr(a).")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.cliente.pessoa_nome))+",\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-044adebd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/graficos-simulador/Saudacao.vue
// module id = null
// module chunks = 